export const LOAD_MODEL = "LOAD_MODEL";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const UPDATE_STATS = "UPDATE_STATS";
export const COLAPSE_DASH = "COLAPSE_DASH";
//table  constans
export const UPDATE_TABLE = "UPDATE_TABLE";
export const RESET_TABLE = "RESET_TABLE";
export const RESIZE_TABLE = "RESIZE_TABLE";

// user constans
export const DELETE_USER = "DELETE_USER";
export const USER_INFO = "USER_INFO";
export const SIGN_OUT = "SIGN_OUT";
export const STATUS = "STATUS";

// viewer & filters
export const TEMPLATE = "TEMPLATE";
export const CATEGORY = "CATEGORY";
export const SECOND = "SECOND";
export const RESET = "RESET";
export const CLEAR_SETTING_VIEWER = 'CLEAR_SETTING_VIEWER'

//template
export const ADD_FOLDER = "ADD_FOLDER";
export const ADD_TEMPLATE = "ADD_TEMPLATE";
export const DELETE_FOLDER = "DELETE_FOLDER";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const RENAME_FOLDER = "RENAME_FOLDER";
export const EDIT_TEMPLATE = "EDIT_TEMPLATE";

//collections
export const GET_FOLDERS_COLLECTIONS = "GET_FOLDERS_COLLECTIONS";
export const SAVE_COLLECTION = "SAVE_COLLECTION";
export const SAVE_COLLECTIONS = "SAVE_COLLECTIONS";
export const CREATE_COLLECTIONS_FOLDER = "CREATE_COLLECTIONS_FOLDER";
export const RENAME_COLLECTIONS_FOLDER = "RENAME_COLLECTIONS_FOLDER";
export const DELETE_COLLECTIONS_FOLDER = "DELETE_COLLECTIONS_FOLDER";
export const EDIT_COLLECTIONS = "EDIT_COLLECTIONS";
export const DELETE_COLLECTIONS = "DELETE_COLLECTIONS";
export const UNASSIGN_FROM_COLLECTIONS = "UNASSIGN_FROM_COLLECTIONS";
export const ADD_TO_NEW_COLLECTION = "ADD_TO_NEW_COLLECTION";
export const COPY_TO_COLLECTION = "COPY_TO_COLLECTION";
export const COPY_TO_COLLECTION_UNSAVED = "COPY_TO_COLLECTION_UNSAVED";
export const ADD_ACTIVE_FOLDER = "ADD_ACTIVE_FOLDER";
export const ASSIGN_TO_COLLECTION = "ASSIGN_TO_COLLECTION";
export const SET_MODE_COMPARE = "SET_MODE_COMPARE";
export const CHANGE_COLLECTION_CHECKBOX = "CHANGE_COLLECTION_CHECKBOX";
export const SET_QUICK_INFO_COMPARE = "SET_QUICK_INFO_COMPARE";

//tabs
export const GET_COLLECTION_TABLE = "GET_COLLECTION_TABLE";
export const CLOSE_TAB = "CLOSE_TAB";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const REPLACE_TAB = "REPLACE_TAB";
export const ADD_SELECT_ITEMS = "ADD_SELECT_ITEMS";
